import React, { useEffect } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { hideToast } from '../stores/toastSlice';

const ToastComponent = () => {

    const dispatch = useDispatch();
    const { show, message } = useSelector((state) => state.toast);

    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                dispatch(hideToast());
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, [show, dispatch]);

    return (
        <div
            className={`toast-container position-fixed top-0 start-0 p-3 ${show ? 'show' : 'hide'}`}
            style={{ zIndex: 1050 }}
        >
            <div className={`toast align-items-center bg-light text-dark toast-background ${show ? 'show' : ''}`} role="alert">
                <div className="d-flex">
                    <div className="toast-body">{message}</div>
                    <button
                        type="button"
                        className="btn-close me-2 m-auto"
                        aria-label="Close"
                        onClick={() => dispatch(hideToast())}
                    ></button>
                </div>
            </div>
        </div>
    );
}

export default ToastComponent;
